"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageWizardActions = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@veeam/core");
const Button_1 = require("../../../Button");
const helpers_1 = require("../../../helpers");
const StackView_1 = require("../../../StackView");
const Root = (0, styled_components_1.default)(StackView_1.StackView) `
    ${Button_1.Button.selector} {
        min-width: ${helpers_1.FIELD_XXS};
    }
`;
function PageWizardActions(props) {
    const { t } = (0, core_1.useFeatureContext)();
    const renderDoneButton = () => {
        const { done, loading } = props;
        return (react_1.default.createElement(Button_1.Button, { key: 'done', style: done.hidden ? { visibility: 'hidden' } : {}, disabled: done.disabled || loading, onClick: () => {
                var _a;
                (_a = done.didSelect) === null || _a === void 0 ? void 0 : _a.call(done);
            }, onKeyDown: (e) => {
                if (e.keyCode === helpers_1.KeyCode.Enter) {
                    e.stopPropagation();
                }
            } }, done.title || t('wizard|actions|done') || 'Finish'));
    };
    const renderCancelButton = () => {
        const { cancel, loading } = props;
        return (react_1.default.createElement(Button_1.Button, { key: 'cancel', style: cancel.hidden ? { visibility: 'hidden' } : {}, ui: Button_1.BUTTON_VIEW.secondary, disabled: cancel.disabled || loading, onClick: () => {
                var _a;
                (_a = cancel.didSelect) === null || _a === void 0 ? void 0 : _a.call(cancel);
            }, onKeyDown: (e) => {
                if (e.keyCode === helpers_1.KeyCode.Enter) {
                    e.stopPropagation();
                }
            } }, cancel.title || t('wizard|actions|cancel') || 'Cancel'));
    };
    const renderPreviousButton = () => {
        const { prev, loading } = props;
        return (react_1.default.createElement(Button_1.Button, { ui: Button_1.BUTTON_VIEW.alternate, style: prev.hidden ? { visibility: 'hidden' } : {}, disabled: prev.disabled || loading, onClick: () => {
                var _a;
                (_a = prev.didSelect) === null || _a === void 0 ? void 0 : _a.call(prev);
            }, onKeyDown: (e) => {
                if (e.keyCode === helpers_1.KeyCode.Enter) {
                    e.stopPropagation();
                }
            } }, prev.title || t('wizard|actions|previous') || 'Previous'));
    };
    const renderNextButton = () => {
        const { next, loading } = props;
        return (react_1.default.createElement(Button_1.Button, { style: props.next.hidden ? { visibility: 'hidden' } : {}, disabled: next.disabled || loading, onClick: () => {
                var _a;
                (_a = next.didSelect) === null || _a === void 0 ? void 0 : _a.call(next);
            }, onKeyDown: (e) => {
                if (e.keyCode === helpers_1.KeyCode.Enter) {
                    e.stopPropagation();
                }
            } }, next.title || t('wizard|actions|next') || 'Next'));
    };
    return (react_1.default.createElement(Root, { direction: StackView_1.STACK_DIRECTION.row, gap: StackView_1.STACK_GAP.m, align: StackView_1.STACK_ALIGN.center, distribution: StackView_1.STACK_DISTRIBUTION.end },
        react_1.default.createElement(StackView_1.StackView, { root: true, gap: StackView_1.STACK_GAP.m, align: StackView_1.STACK_ALIGN.center, distribution: StackView_1.STACK_DISTRIBUTION.end },
            react_1.default.createElement(Button_1.Button, { ui: Button_1.BUTTON_VIEW.alternate, style: { visibility: 'hidden' }, disabled: true }, props.prev.title || t('wizard|actions|previous') || 'Previous'),
            react_1.default.createElement(Button_1.Button, { style: { visibility: 'hidden' }, disabled: true }, props.next.title || t('wizard|actions|next') || 'Next'),
            react_1.default.createElement(Button_1.Button, { key: 'done', style: { visibility: 'hidden' }, disabled: true }, props.done.title || t('wizard|actions|done') || 'Finish'),
            react_1.default.createElement(Button_1.Button, { key: 'cancel', style: { visibility: 'hidden' }, ui: Button_1.BUTTON_VIEW.secondary, disabled: true }, props.cancel.title || t('wizard|actions|cancel') || 'Cancel'),
            react_1.default.createElement(StackView_1.StackView, { style: { position: 'absolute', top: 0, left: 0, bottom: 0, right: 0 }, gap: StackView_1.STACK_GAP.m, distribution: StackView_1.STACK_DISTRIBUTION.lastFill },
                react_1.default.createElement(StackView_1.StackView, { gap: StackView_1.STACK_GAP.m },
                    renderPreviousButton(),
                    !props.next.hidden && renderNextButton(),
                    !props.done.hidden && renderDoneButton(),
                    renderCancelButton())))));
}
exports.PageWizardActions = PageWizardActions;
//# sourceMappingURL=PageWizardActions.js.map